import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { IValidateManager } from '../services/pre-login.model';

interface IManagerEmail{
  email: string ;
}

@Injectable({
  providedIn: 'root'
})
export class ValidateManagerEmailService {

  rootScopeData: RootScopeDeclare;

  constructor(private httpClient: HttpClient, private rootScopeService: RootScopeService, private httpHeaderService: HttpHeadersService) {
    this.getRootScopeData();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  validateManagerEmail(dataInput: IManagerEmail): Observable<IValidateManager> {
   const headers = this.httpHeaderService.preLoginHttpAuthorizationHeader();
   const result = this.httpClient.post(environment.servicePath + '/register/manager/validate', dataInput, { headers});
   return result as Observable<IValidateManager>;

  }
}
